<ul class="sidenav__list">
  @for (link of links; track link) {
  <li>
    @if (link.ext) {
    <a [href]="link.link" target="_blank">
      {{ link.label }}
    </a>
    } @if (!link.ext) {
    <a [routerLink]="link.link">
      {{ link.label }}
    </a>
    }
  </li>
  }
</ul>
